import { createModel } from '@rematch/core';

const state = {};

export default createModel({
  state,
  reducers: {},
  effects: {},
});
